import { DataTableMeta } from '@otp/ui';
import { TFunction } from 'i18next';
import { User } from 'src/graphql/generated/graphql';
import { ActionsColumn, ActionType } from './columns/actions';
import { Link } from 'src/components/common/link';
import { Routes } from 'src/components/common/router/constants';

export const getTableConfig = (
  users: Partial<User>[],
  {
    t,
    onChange,
    action,
    withLinks,
  }: {
    t: TFunction;
    onChange: (id: string) => void;
    action: ActionType;
    withLinks?: boolean;
  },
) => [
  {
    name: 'firstName',
    label: t('common.firstName'),
    options: {
      customBodyRender: (value: string, column: DataTableMeta) => {
        const user = users[column.rowIndex];

        if (withLinks) {
          return (
            <Link to={`${Routes.users.path}/${user.id}`} target="_blank">
              {value}
            </Link>
          );
        }

        return value;
      },
    },
  },
  {
    name: 'lastName',
    label: t('common.lastName'),
  },
  {
    name: 'email',
    label: t('common.email'),
  },
  {
    name: 'actions',
    label: t('common.actions'),
    options: {
      customBodyRender: (_: any, column: DataTableMeta) => {
        const user = users[column.rowIndex];

        return (
          <ActionsColumn onChange={() => onChange(user.id)} action={action} />
        );
      },
    },
  },
];
